import RecategorizacionModal from "./RecategorizacionModal";
export default RecategorizacionModal;